import Enum from "./Enum";

export default Enum.create( {
	STARTED: "STARTED",
	COMPLETED: "COMPLETED",
	PUBLISHED: "PUBLISHED",
} );
